require([
    "jquery", "moment",
    "signature-pad",
    "jquery.uniform", "jquery-form",
    "bootstrap-multiselect", "bootstrap-colorpicker",
    'jquery-ui', "bootstrap-datetimepicker", "bootbox", "js-base64",
    "autosize"
], function () {

});

define("listAndFormLibs", function(){});

